// extracted by mini-css-extract-plugin
export default {"text1":"login_text1__95jjr","text2":"login_text2__nBJFR","text3":"login_text3__MWM37","text4":"login_text4__GMcz6","text5":"login_text5__q68W-"};